import styled from 'styled-components';

export const FeedbackWrapper = styled.span`
  color: ${({ theme }) => theme.colors.link};
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  cursor: pointer;
`;
